export default {
  log: {
    level: 'ERROR'
  },
  analytics: {
    gtm: {
      id: 'GTM-K24Q67D'
    }
  },
  featureFlag: {
    key: `4v1fspmon4j1qrpjrkfcd90sae9bug822feq`
  }
};
